import React, { Fragment } from 'react';

export const NAVS = ['ACTIVE', 'BASIC', 'OPTIONAL LENSES'];

export const RECOMMENDED = [
  {
    src: '/color.webp',
    title: 'Colour Lenses',
    desc: 'Pair them with your favourite spectacle frame to elevate your style or use them as sunglasses',
    link: '/sg/en/services/lens#color',
  },
  {
    src: '/transition.webp',
    title: 'Transitions Lenses',
    desc: 'Lens colour changes based on amount of UV, allowing your spectacles to double as sunglasses',
    link: '/sg/en/services/lens#transitions-light',
  },
  {
    src: '/blue.webp',
    title: 'Blue Light Lenses',
    desc: 'Protect your eyes from blue light when using the computer or smartphone',
    link: '/sg/en/services/lens#blue-light-lenses',
  },
  {
    src: '/polarised.webp',
    title: 'Polarised Lenses',
    desc: 'Reduce glare on shiny surfaces like water, making them perfect for the outdoors',
    link: '/sg/en/services/lens#polarised',
  },
  {
    src: '/antifog.webp',
    title: 'Anti-Fog Lenses',
    desc: 'With a special coating that prevents the lenses from fogging up, keeping your vision crystal clear at all times',
    link: '/sg/en/services/lens#antifog',
  },
  {
    src: '/progressive.webp',
    title: 'Progressive Lenses',
    desc: 'Just one pair of glasses to see far, intermediate and reading zones',
    link: '/sg/en/services/lens#progressive',
  },
];

export const STYLES = {
  active: {
    title: 'ACTIVE',
    desc: 'Designed for a secure fit even when you are on the move',
    concept: {
      '4-level': {
        tag: '4-level adjustment - temple ends',
        title: 'A Comfortable Fit That Lasts',
        desc: 'The adjustable temple ends allow you to adjust the fit of the glasses according to the occasion. You can choose to wear them snugly for a more secure fit or loosely for a more relaxed feel.',
        img: {
          big: {
            alt: 'A Comfortable Fit That Lasts',
            pc: '/active/active-cover-1_pc.webp',
            sp: '/active/active-cover-1_sp.webp',
          },
          small: {
            alt: `Wear and it's a perfect Fit!`,
            img: '/active/fit-1.webp',
          },
        },
        recommended: {
          badge: (
            <Fragment>
              4 levels <br />
              of
              <br /> adjustability
            </Fragment>
          ),
          alt: '4 levels of adjustability',
          img: '/products/gif/MV2003N-5S.gif',
          titles: [
            <Fragment key="recommended-1">
              Temples can be adjusted at two points
              <br /> in four different ways
            </Fragment>,
            'Customise the fit around the ears',
          ],
          listHeader: 'Recommended For',
          list: ['I want to improve the fit', 'I want to look smart'],
        },
        recommendedPerfect: {
          title: 'Perfect fit for every occasion!',
          tag: 'Recommended Usage',
          list: [
            {
              altStage: '1st stage',
              text: 'Daily Use and Helmet Wear',
            },
            {
              altStage: '2nd stage',
              text: 'Off Days/Leisure Time',
            },
            {
              altStage: '3rd stage',
              text: 'Office Work/Close-up Tasks',
            },
            {
              altStage: '4th stage',
              text: 'Running, gym and other intense workouts',
            },
          ],
        },
      },
      '2-step': {
        tag: '2-step adjustment - temple arm width',
        title: 'A comfortable fit tailored to your face width',
        desc: 'The temples can be adjusted to 2 different widths to give you a customised fit. Whether you prefer a snug fit or a more relaxed fit, this is the perfect eyewear for both day-to-day and active use.',
        img: {
          big: {
            alt: 'A comfortable fit tailored to your face width',
            pc: '/active/active-cover-2_pc.webp',
            sp: '/active/active-cover-2_sp.webp',
          },
          small: {
            alt: `Adjust for a Perfect Fit!`,
            img: '/active/fit-2.webp',
          },
        },
        recommended: {
          alt: 'OWNDAYS’ unique slide structure, adjust the temple width in two steps',
          img: '/products/gif/MV2005N-5S.gif',
          titles: ['OWNDAYS’ unique slide structure', 'Adjust the temple width in two steps'],
          listHeader: 'Recommended For',
          list: ['I want to choose based on comfort', 'I want a subtle active vibe'],
        },
      },
    },
  },
  basic: {
    title: 'BASIC',
    desc: 'Suitable for daily life and sports use',
    concept: {
      desc: 'Featuring rubber temple ends and nose pads that provide a secure fit, this basic model is functional and perfect for everyday use.',
      img: {
        big: {
          alt: 'Suitable for daily life and sports use',
          pc: '/basic/basic-cover_pc.webp',
          sp: '/basic/basic-cover_sp.webp',
        },
      },
    },
    features: {
      title: 'FEATURES',
      list: [
        'Rubber temple ends for a more secure fit',
        'Rubber temples for a comfortable fit',
        'Made of G850, a lightweight and eco-friendly material',
      ],
    },
  },
};

export const PRODUCTS = {
  'MV2001N-5S': {
    productNumber: 'MV2001N-5S',
    price: '178',
    colors: ['matte-black', 'black', 'light-brown', 'black'],
    limit: 5,
  },
  'MV2002N-5S': {
    productNumber: 'MV2002N-5S',
    price: '178',
    colors: ['matte-black', 'grey', 'light-brown', 'dark-green'],
    limit: 5,
  },
  'MV2003N-5S': {
    productNumber: 'MV2003N-5S',
    price: '178',
    colors: ['matte-black', 'matte-grey', 'matte-khaki', 'matte-navy'],
    limit: 7,
  },
  'MV2004N-5S': {
    productNumber: 'MV2004N-5S',
    price: '178',
    colors: ['matte-black', 'matte-khaki', 'light-brown', 'white'],
    limit: 7,
  },
  'MV2005N-5S': {
    productNumber: 'MV2005N-5S',
    price: '178',
    colors: ['matte-black', 'matte-grey', 'dark-green', 'black-2a'],
    limit: 6,
  },
  'MV2006N-5S': {
    productNumber: 'MV2006N-5S',
    price: '178',
    colors: ['black', 'grey', 'matte-navy', 'dark-green'],
    limit: 6,
  },
};
